export const defaultProps={
  color:{white:"#FFF"}
}